import type { AssociationPolicyResponseDto } from '@/entities/association-policy/types';
import { dm_DRSAlgo1, dm_DRSAlgo4, dm_DRSAlgo6, dm_DRSAlgo7 } from './device-models.mock';
import { org_SofiaHospital, org_BarcelonaHospital } from './organizations.mock';
import { DeviceModelFactorySettings } from '../device-model';

export const ap_ManualDRSAlgo1: AssociationPolicyResponseDto = {
    id: 'a1b2c3d4-e5f6-4789-a012-3456789abcde',
    organizationId: org_SofiaHospital.organizationId,
    deviceModelId: dm_DRSAlgo1.id,
    name: 'DRC in ICU',
    deploymentMode: 'Staging',
    status: 'Phasing out',
    associationType: 'Manual',
    associationRule: null,
    dissociationRule: null,
    description: 'Manual association for DRSAlgo 1',
    factorySettings: structuredClone(dm_DRSAlgo1.factorySettings),
    runningDevices: 0
};

export const ap_AutomaticDRSAlgo4: AssociationPolicyResponseDto = {
    id: 'b2c3d4e5-f6a7-4890-b123-456789abcdef0',
    organizationId: org_BarcelonaHospital.organizationId,
    deviceModelId: dm_DRSAlgo4.id,
    name: 'DRC in ICU',
    deploymentMode: 'Production',
    status: 'Running',
    associationType: 'Automatic',
    associationRule: 'device.location == ward.id',
    dissociationRule: 'device.status == "offline"',
    description: 'Auto-assign when device enters ward',
    factorySettings: structuredClone(dm_DRSAlgo4.factorySettings),
    runningDevices: 0
};

export const ap_Sofia_ManualAlgo6_Production_Running: AssociationPolicyResponseDto = {
    id: 'c3d4e5f6-a7b8-4901-c234-567890abcdef1',
    organizationId: org_SofiaHospital.organizationId,
    deviceModelId: dm_DRSAlgo6.id,
    name: 'DRS in ICU',
    deploymentMode: 'Production',
    status: 'Running',
    associationType: 'Manual',
    associationRule: null,
    dissociationRule: null,
    description: 'Production policy for ICU ward',
    factorySettings: structuredClone(dm_DRSAlgo6.factorySettings)
        .map((setting): DeviceModelFactorySettings => setting.name === 'Delay' && setting.type === 'Number'
            ? { ...setting, defaultValue: 30 }
            : setting),
    runningDevices: 3,
};

export const ap_Sofia_AutomaticAlgo6_Staging_Running: AssociationPolicyResponseDto = {
    id: 'd4e5f6a7-b8c9-4012-d345-678901abcdef2',
    organizationId: org_SofiaHospital.organizationId,
    deviceModelId: dm_DRSAlgo6.id,
    name: 'DRS for patients tachycardia',
    deploymentMode: 'Staging',
    status: 'Running',
    associationType: 'Automatic',
    associationRule: 'device.heartRate > 100',
    dissociationRule: 'device.heartRate <= 100',
    description: 'Auto-assign for tachycardia monitoring',
    factorySettings: structuredClone(dm_DRSAlgo6.factorySettings),
    runningDevices: 4,
};

export const ap_Sofia_ManualAlgo7_Production_PhasingOut: AssociationPolicyResponseDto = {
    id: 'e5f6a7b8-c9d0-4123-e456-789012abcdef3',
    organizationId: org_SofiaHospital.organizationId,
    deviceModelId: dm_DRSAlgo7.id,
    name: 'MvCRE in ICU',
    deploymentMode: 'Production',
    status: 'Phasing out',
    associationType: 'Manual',
    associationRule: null,
    dissociationRule: null,
    description: 'Being replaced by newer model',
    factorySettings: structuredClone(dm_DRSAlgo7.factorySettings)
        .map((setting): DeviceModelFactorySettings => setting.name === 'Display label' && setting.type === 'String'
            ? { ...setting, defaultValue: 'MvCRE' }
            : setting),
    runningDevices: 2,
};

export const ap_Sofia_ManualAlgo7_Production_Stopped: AssociationPolicyResponseDto = {
    id: 'f6a7b8c9-d0e1-4234-f567-890123abcdef4',
    organizationId: org_SofiaHospital.organizationId,
    deviceModelId: dm_DRSAlgo7.id,
    name: 'MvCRE in ER',
    deploymentMode: 'Production',
    status: 'Stopped',
    associationType: 'Manual',
    associationRule: null,
    dissociationRule: null,
    description: null,
    factorySettings: structuredClone(dm_DRSAlgo7.factorySettings),
    runningDevices: 0,
};

export const ap_Sofia_AutomaticAlgo7_Staging_Stopped: AssociationPolicyResponseDto = {
    id: 'a7b8c9d0-e1f2-4345-a678-901234abcdef5',
    organizationId: org_SofiaHospital.organizationId,
    deviceModelId: dm_DRSAlgo7.id,
    name: 'MvCRE for patient intake',
    deploymentMode: 'Staging',
    status: 'Stopped',
    associationType: 'Automatic',
    associationRule: 'device.ward == "intake"',
    dissociationRule: 'device.ward != "intake"',
    description: 'Staging test for intake ward',
    factorySettings: structuredClone(dm_DRSAlgo7.factorySettings),
    runningDevices: 0,
};

export const associationPoliciesMock: AssociationPolicyResponseDto[] = [
    ap_ManualDRSAlgo1,
    ap_AutomaticDRSAlgo4,
    ap_Sofia_ManualAlgo6_Production_Running,
    ap_Sofia_AutomaticAlgo6_Staging_Running,
    ap_Sofia_ManualAlgo7_Production_PhasingOut,
    ap_Sofia_ManualAlgo7_Production_Stopped,
    ap_Sofia_AutomaticAlgo7_Staging_Stopped,
];
